angular.module('myApp.directives')
    .directive('initApplication', function() {
        return {
            restrict: 'A',
            priority: 100,
            link: function(scope, element, attrs) {},
            controller: function($scope, $element, $attrs, $transclude, clientTools, user, tokensStorage) {
                $scope.hasSupportGetUserMedia           = clientTools.hasSupportGetUserMedia();
                $scope.isAVResponseEnabled              = clientTools.isAVResponseEnabled();
                $scope.userId                           = $attrs.userid;
                user.setUserData({'userId': $attrs.userid});
                clientTools.setNodeJsHost($attrs.nodejshost);
                if ($attrs.mobileLayout == 1) {
                    clientTools.setIsMobileLayout();
                }
                if ($attrs.bandwidth) {
                    var bandwidth = {};
                    try {
                        bandwidth = JSON.parse($attrs.bandwidth);
                    } catch (e) {
                        console.log('Error when parsing json :', $attrs.bandwidth);
                    }
                    if (bandwidth.enabled == 1) {
                        if (bandwidth.download > 0 && bandwidth.upload > 0) {
                            clientTools.setInternetSpeed(bandwidth);
                        } else {
                            $(document).ready(function () {
                                clientTools.makeSpeedTest(60, function () {
                                    $scope.$broadcast("startUserMedia");
                                });
                            });
                        }
                    }
                }
                tokensStorage.setToken($attrs.token);
            }
        }
    });